import { RedirectionConfig } from '../../../models';

export const DEFAULT_REDIRECTION_CONFIG: RedirectionConfig = {
  autoRedirect: true
};
